import ApiService from "@/common/api/api.service";
//import helpers from "@/common/utils/helpers";

const PlanejamentoService = {
  
    store: function(form) {
        return ApiService.post(`PlanejamentoEstrategico`, form);
    },

    get: function(id) {
        return ApiService.get(`PlanejamentoEstrategico/${id}`);
    },

    fetch: function(perPage = 0, page = 0) {
        return ApiService.get(`PlanejamentoEstrategico?TamanhoDaPagina=${perPage}&NumeroDaPagina=${page}`);
    },


};

export default PlanejamentoService;
